/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from 'react';
import { Avatar } from '@mui/material';
import PropTypes from 'prop-types';
import RoleIndicator from './RoleIndicator';

const defaultProfileImage = '/assets/profile/default-profile-image.svg';

const AvatarRole = ({
  user = null,
  small = false,
  subComment = false,
  style = {},
  unsetTopMargin = false,
  medium,
  overrideStyle,
}) => (
  <div
    className="avatar-role-wrapper"
    style={style}
    role="button"
    tabIndex={0}
  >
    <Avatar
      className="ph-no-capture"
      src={user?.profile_image}
      sx={{
        fontFamily: "'Sarabun', arial, sans-serif",
        ...(small && { width: 30, height: 30 }),
        ...(subComment && { width: 25, height: 25 }),
        ...(subComment && { fontSize: '12px' }),
        ...(medium && { width: 60, height: 60 }),
        mt: unsetTopMargin ? 0 : '16px',
        ...overrideStyle?.avatar,
      }}
    >
      <img
        src={defaultProfileImage}
        alt="profile"
        style={{
          ...(small && { width: 30, height: 30 }),
          ...(subComment && { width: 25, height: 25 }),
          ...(subComment && { fontSize: '12px' }),
          mt: unsetTopMargin ? 0 : '16px',
          ...(medium && { width: 60, height: 60 }),
          width: 40,
          height: 40,
          ...overrideStyle?.avatar,
        }}
      />
    </Avatar>
    <RoleIndicator
      roles={user?.roles || []}
      legacyRole={user?.role}
      style={{
        position: 'absolute',
        ...(medium && {
          bottom: '.5rem',
          right: '2rem',
          width: 18,
          height: 18,
          fontSize: '12px',
        }),
        ...(small
          ? {
            bottom: '-4px', right: '-1px', width: 14, height: 14, fontSize: '0.5625rem',
          }
          : { bottom: '-2px', right: 0 }),
        ...(subComment
          ? {
            bottom: '-4px', right: '-1px', width: 12, height: 12, fontSize: '0.5625rem',
          }
          : { bottom: '-2px', right: 0 }),
        ...overrideStyle?.roleIndicator,
      }}
    />
  </div>
);

AvatarRole.propTypes = {
  user: PropTypes.shape({
    first_name: PropTypes.string,
    last_name: PropTypes.string,
    profile_image: PropTypes.string,
    role: PropTypes.string,
    roles: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.number,
      name: PropTypes.string,
    })),
  }),
  small: PropTypes.bool,
  subComment: PropTypes.bool,
  unsetTopMargin: PropTypes.bool,
  style: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
};


export default AvatarRole;
